import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { embedYouTubeInHTML } from '../../utils/youtube';

// iframe 태그와 관련 속성을 허용 (YouTube 임베드용)
const PURIFY_CONFIG = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'src', 'style'],
};

// YouTube가 아닌 iframe은 제거
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'IFRAME') {
    const src = node.getAttribute('src') || '';
    if (!src.startsWith('https://www.youtube.com/embed/')) {
      node.remove();
    }
  }
});

const ContentViewer = ({ text, sx, ...otherProps }) => {
  const htmlWithEmbeds = embedYouTubeInHTML(text);

  return (
    <Typography
      variant="body3"
      sx={[
        {
          '& *': { lineHeight: 1.5 },
          '& p': { margin: 0 },
          '& img': { maxWidth: '100%', height: 'auto' },
        },
        sx,
      ]}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(htmlWithEmbeds, PURIFY_CONFIG),
      }}
      {...otherProps}
    />
  );
};

export default ContentViewer;
